import 'debug';
import { E as EventHub, _ as _asyncToGenerator, h as _regeneratorRuntime } from './index2.js';
import 'deepmerge';
import 'axios';
import 'vue';
import Slider from './Slider.js';
import { _ as __vue_normalize__ } from './normalize-component.js';
import { l as lipSync } from './lipSync.js';

/**
 * Audio player for audio files.
 * @displayName Audio Player
 */

var script = {
  mixins: [lipSync],
  props: {
    audioSync: {
      default: function _default() {
        return {};
      }
    },
    source: {
      type: String,
      required: true
    },
    bottomFixed: {
      default: function _default() {
        return true;
      }
    },
    binaryId: {
      type: Number,
      required: true
    },
    pageId: {
      type: Number,
      required: true
    },
    autoPlay: {
      default: false
    },
    lipSyncUrl: {
      type: String,
      default: null,
      validator: function validator(value) {
        return value === null || (typeof value === 'string' || value instanceof String) && value.startsWith('ws://');
      }
    }
  },
  data: function data() {
    return {
      showVolumeControl: false,
      audioSyncKeys: [],
      playing: false,
      progress: 0,
      duration: 0,
      ready: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$xp.device.getRemappedUrl(this.source).then(function (remappedUrl) {
      console.log(_this.audioSync);
      _this.audioSyncKeys = Object.keys(_this.audioSync);

      for (var i = 0; i < _this.audioSyncKeys.length; i++) {
        _this.audioSyncKeys[i] = parseInt(_this.audioSyncKeys[i]);
      }

      _this.sound = document.createElement('audio');
      _this.sound.autoplay = _this.autoplay;

      _this.sound.classList.add('c-audio-player__element');

      _this.sound.controls = false;
      _this.sound.src = remappedUrl;
      _this.sound.type = 'audio/mp3';
      _this.sound.disableRemotePlayback = true;
      _this.sound.volume = _this.$xp.media.volume;

      _this.sound.load();

      _this.$el.appendChild(_this.sound); // this.sound = this.$el.querySelector('.js-audioElement')


      _this.sound.addEventListener('loadedmetadata', _this.onLoadedMetadata);

      _this.sound.addEventListener('canplaythrough', _this.onCanPlayThrough);

      _this.sound.addEventListener('canplay', _this.onCanPlay);

      _this.sound.addEventListener('play', _this.onAudioPlay);

      _this.sound.addEventListener('timeupdate', _this.onTimeUpdate);

      _this.sound.addEventListener('pause', _this.onAudioPause);

      _this.sound.addEventListener('ended', _this.onAudioEnded);

      _this.sound.addEventListener('error', _this.onAudioError);
    });
    EventHub.Bus.$on(EventHub.TYPES.START_PLAY_MEDIA, this.onStartPlayMedia);
    EventHub.Bus.$on(EventHub.TYPES.ANDROID_ACTIVITY_PAUSE, this.onActivityPause);
    window.addEventListener('keyup', this.onKeyEvent);
  },
  beforeDestroy: function beforeDestroy() {
    this.sound.autoplay = false;
    this.sound.muted = true;
    this.$emit('media-session-ended');
    this.stopLipSync();
    this.isLipSync && this.$xp.wifi.releaseWifiConnectionOn('videoSync');
    this.sound.removeEventListener('loadedmetadata', this.onLoadedMetadata);
    this.sound.removeEventListener('canplaythrough', this.onCanPlayThrough);
    this.sound.removeEventListener('canplay', this.onCanPlay);
    this.sound.removeEventListener('play', this.onAudioPlay);
    this.sound.removeEventListener('timeupdate', this.onTimeUpdate);
    this.sound.removeEventListener('pause', this.onAudioPause);
    this.sound.removeEventListener('ended', this.onAudioEnded);
    this.sound.removeEventListener('error', this.onAudioError);
    this.sound.removeEventListener('keyup', this.onKeyEvent);
    EventHub.Bus.$off(EventHub.TYPES.START_PLAY_MEDIA, this.onStartPlayMedia);
    EventHub.Bus.$off(EventHub.TYPES.ANDROID_ACTIVITY_PAUSE, this.onActivityPause);

    if (this.playing) {
      this.sound.pause();
      this.onAudioPause();
    }

    this.sound.parentNode.removeChild(this.sound);
    this.sound.removeAttribute('src');
    this.sound.load();
    this.sound = null;
  },
  methods: {
    onLoadedMetadata: function onLoadedMetadata(e) {
      this.duration = this.sound.duration;
    },
    onCanPlay: function onCanPlay() {
      // Fallback for Firefox 62.1 sometimes does not send 'canplaythrough'
      var self = this;

      if (this.sound && !self.ready) {
        setTimeout(function () {
          if (!self.ready) {
            self.onCanPlayThrough();
          }
        }, 4000);
      }
    },
    onCanPlayThrough: function () {
      var _onCanPlayThrough = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var shouldRestoreState, historyCurrentTime, historyPlayingState;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.sound) {
                  _context.next = 17;
                  break;
                }

                if (!this.isLipSync) {
                  _context.next = 10;
                  break;
                }

                if (this.ready) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return this.$xp.wifi.lockWifiConnectionOn('videoSync');

              case 5:
                _context.next = 7;
                return this.$xp.network.waitForOnline();

              case 7:
                this.startLipSync(this.sound);

              case 8:
                _context.next = 17;
                break;

              case 10:
                shouldRestoreState = !this.ready && this.$route.query.ref !== 'beacon';
                console.log('shouldRestoreState: ' + shouldRestoreState);
                historyCurrentTime = this.$xp.history.historyParams['currentTime' + this.binaryId];

                if (shouldRestoreState && historyCurrentTime) {
                  this.sound.currentTime = historyCurrentTime;
                }

                historyPlayingState = this.$xp.history.historyParams['isPlaying' + this.binaryId];

                if (shouldRestoreState && typeof historyPlayingState !== 'undefined') {
                  historyPlayingState ? this.sound.play() : this.sound.pause();
                } else if (!this.ready && this.autoPlay) {
                  this.sound.play();
                }

                this.ready = true;

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onCanPlayThrough() {
        return _onCanPlayThrough.apply(this, arguments);
      }

      return onCanPlayThrough;
    }(),
    onTimeUpdate: function onTimeUpdate() {
      if (this.sound && this.ready) {
        var currentTime = this.sound.currentTime;
        this.progress = currentTime / this.sound.duration;

        if (parseInt(this.$route.params.id) === this.pageId) {
          this.$xp.history.setHistoryParam(this.pageId, 'currentTime' + this.binaryId, currentTime);
        }
      }
    },
    onAudioPlay: function onAudioPlay() {
      this.setPlayingState(true);
      EventHub.Bus.$emit(EventHub.TYPES.START_PLAY_MEDIA, this._uid);
      this.$emit('media-playing');
    },
    onAudioPause: function onAudioPause() {
      this.setPlayingState(false);
      this.$emit('media-pause');
    },
    onAudioEnded: function onAudioEnded() {
      if (this.sound) {
        this.sound.pause(); // Jump a little bit back, so on going back to this page onVideoEnded() is not called automatically again

        this.sound.currentTime -= 0.1;
        this.onTimeUpdate();
        this.setPlayingState(false);

        if (this.$xp.navigation.childPagesMenuItems.length && this.$xp.navigation.isChildPagesMenuHidden) {
          this.$xp.navigation.toggleChildPagesMenu();
        } else if (this.$xp.navigation.childPagesMenuItems.length === 0 && this.$xp.history.nextPageId && this.$xp.settings.mergedSettings.navigation.nextPageOnMediaEnd) {
          this.$router.push('/page/' + this.$xp.history.nextPageId);
        } else if (this.$xp.navigation.childPagesMenuItems.length === 0 && this.$xp.settings.mergedSettings.navigation.backOnAudioEnd) {
          this.$xp.history.back();
        }
      }
    },
    onAudioError: function onAudioError(e) {
      console.log(e);
    },
    onStartPlayMedia: function onStartPlayMedia(uid) {
      if (this.sound && this._uid !== uid) {
        this.sound.pause();
      }
    },
    onActivityPause: function onActivityPause() {
      if (this.sound) {
        this.sound.pause();
      }
    },
    setPlayingState: function setPlayingState(isPlaying) {
      this.playing = isPlaying;
      this.$xp.media.setIsMediaPlaying(isPlaying);

      if (parseInt(this.$route.params.id) === this.pageId) {
        this.$xp.history.setHistoryParam(this.pageId, 'isPlaying' + this.binaryId, isPlaying);
      }
    },
    togglePlayback: function togglePlayback() {
      if (this.sound && this.ready) {
        if (!this.playing) {
          this.sound.play();
        } else {
          this.sound.pause();
        }
      }
    },
    onKeyEvent: function onKeyEvent(e) {
      var nKey = e.keyCode; // console.log("onKeyEvent " + nKey);

      switch (nKey) {
        case 27:
          // ESC
          console.log('KeyEvent: Audio StopPlay');
          this.sound.pause();
          break;

        case 32: // Space

        case 75:
          // K
          console.log('KeyEvent: Audio TogglePlay');
          this.togglePlayback();
          break;

        case 37:
          // <-
          console.log('KeyEvent: Audio Backward');
          this.sound.currentTime -= 15;
          this.onTimeUpdate();
          break;

        case 39:
          // ->
          console.log('KeyEvent: Audio Forward');
          this.sound.currentTime += 15;
          this.onTimeUpdate();
          break;

        /** NO NEED for volum control in browser */
        // case 38: // arrow up
        //   if (this.showVolumeControl) {
        //     console.log('KeyEvent: Audio Volume Up', this.playbackVolume)
        //     this.playbackVolume = Math.min(this.playbackVolume + 0.1, 1)
        //   }
        //   break
        // case 40: // arrow down
        //   if (this.showVolumeControl) {
        //     console.log('KeyEvent: Audio Volume Down', this.playbackVolume)
        //     this.playbackVolume = Math.max(this.playbackVolume - 0.1, 0)
        //   }
        //   break
      }
    },
    locationOf: function locationOf(element, array, start, end) {
      start = start || 0;
      end = end || array.length;
      var pivot = parseInt(start + (end - start) / 2, 10);

      if (end - start <= 1 || array[pivot] === element) {
        return pivot;
      }

      if (array[pivot] < element) {
        return this.locationOf(element, array, pivot, end);
      } else {
        return this.locationOf(element, array, start, pivot);
      }
    }
  },
  computed: {
    isLipSync: function isLipSync() {
      return this.lipSyncUrl != null;
    },
    track: {
      get: function get() {
        return this.progress;
      },
      set: function set(v) {
        if (this.sound) {
          if (!Number.isNaN(v)) {
            this.sound.currentTime = v * this.duration;
          } else {
            console.log('invalid time: ' + v);
          }
        }
      }
    },
    playbackVolume: {
      get: function get() {
        return parseFloat(this.$xp.media.volume);
      },
      set: function set(v) {
        if (!Number.isNaN(v)) {
          this.$xp.media.setGlobalVolume(v);
          this.sound.volume = v;
        } else {
          console.log('invalid volume: ' + v);
        }
      }
    }
  },
  watch: {
    '$xp.navigation.isNavHidden': function $xpNavigationIsNavHidden(value) {
      if (value === true) {
        this.showVolumeControl = false;
      }
    },
    progress: function progress(value) {
      var time = (this.duration * value).toFixed(0);
      var audioSyncItem = this.audioSync[this.audioSyncKeys[this.locationOf(time, this.audioSyncKeys)]];
      var entry = '';

      if (audioSyncItem && !this.$xp.media.isImageZoomDialogActive) {
        entry = "entry-".concat(audioSyncItem.entryId);
        this.$xp.navigation.goToEntry(entry);
      }

      this.$emit('media-progress-changed');
    }
  },
  components: {
    Slider: Slider
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      class: {
        "c-audio-player--is-loading": !_vm.ready,
        "is-hidden":
          _vm.$xp.navigation.isNavHidden &&
          _vm.ready &&
          _vm.bottomFixed &&
          _vm.playing,
        "c-audio-player": true,
        "c-audio-player--bottom-fixed": _vm.bottomFixed
      },
      attrs: { id: "mediaplayer" }
    },
    [
      _c("div", { staticClass: "c-audio-player__wrapper" }, [
        _c(
          "div",
          {
            staticClass: "c-audio-player__duration",
            attrs: {
              role: "progressbar",
              "aria-valuenow": _vm.duration * _vm.progress,
              "aria-valuemin": "0",
              "aria-valuemax": _vm.duration
            }
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm._f("formatPlayTime")(
                    _vm.progress * _vm.duration - _vm.duration
                  )
                ) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-audio-player__progress" },
          [
            _c("slider", {
              attrs: {
                value: _vm.track,
                isMediaProgressSlider: true,
                trackSize: 5,
                isPlaying: _vm.playing,
                isReady: _vm.ready,
                seekable: !_vm.isLipSync
              },
              on: {
                "update:value": function($event) {
                  _vm.track = $event;
                },
                pinTap: _vm.togglePlayback
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.$xp.media.allowUIVolumeControl
        ? _c(
            "button",
            {
              staticClass: "c-audio-player__button",
              attrs: {
                tabindex: "0",
                "aria-label": _vm.$t("global.setVolume")
              },
              on: {
                click: function($event) {
                  _vm.showVolumeControl = !_vm.showVolumeControl;
                }
              }
            },
            [
              _vm.$xp.media.volume >= 0.5
                ? _c("span", { staticClass: "xp xp-volume-up xp--large" })
                : _vm._e(),
              _vm._v(" "),
              _vm.$xp.media.volume < 0.5 && _vm.$xp.media.volume !== 0
                ? _c("span", { staticClass: "xp xp-volume-down xp--large" })
                : _vm._e(),
              _vm._v(" "),
              _vm.$xp.media.volume === 0
                ? _c("span", {
                    staticClass: "xp xp-volume-off xp--large",
                    attrs: { name: "volume-off" }
                  })
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showVolumeControl
        ? _c(
            "div",
            { staticClass: "c-audio-player__volume-control" },
            [
              _c("slider", {
                attrs: {
                  value: _vm.playbackVolume,
                  orientation: "vertical",
                  trackSize: 10
                },
                on: {
                  "update:value": function($event) {
                    _vm.playbackVolume = $event;
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
